export interface VetChatSummaryDto {
  id: string;
  last_message: Date;
  created_at: Date;
  chat_agent: string[];
  title: string;
  category: string;
  summary: string;
  pet_type: string;
  sent_to_clinic: boolean;
  medical_category: string;
  conversationId: string;
  email: string;
  tiername: string;
  phone: string;
  symptoms: string[];
  userId?: string; // Optional field for user lookup, IMPORTANT: Id from user table, not Cognito ID
}
